// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Humanises a provider-metadata key for display. Rate-card options carry
 * free-form provider extras keyed by camelCase / snake / kebab identifiers
 * (e.g. `sCode`, `initialCommissionNote`) — render them as spaced Title Case
 * ("S Code", "Initial Commission Note") so the label reads naturally.
 * Existing capitals (acronyms like "AVCs") are preserved.
 */
export function humanizeMetadataKey(key: string): string {
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // camelCase → spaced
    .replace(/[_-]+/g, ' ') // snake / kebab → spaced
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Title-case each word's first letter
}
